// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import AOS from "aos";
import "../node_modules/aos/dist/aos.css";
import "swiper/dist/css/swiper.css";
import vueSeamlessScroll from 'vue-seamless-scroll'
Vue.component('vue-seamless-scroll', vueSeamlessScroll);
console.log(process.env.NODE_ENV)
    // if (process.env.NODE_ENV === 'development') {
    //     axios.defaults.baseURL = 'http://27.156.10.7:8084'
    // } else

if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = 'http://www.lhtianan.com.cn:8084'
}
// axios.defaults.baseURL = 'http://27.156.10.7:8084'
Vue.use(AOS)
Vue.prototype.$axios = axios
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
})


// WEBPACK FOOTER //
// ./src/main.js